import React, { useState } from "react";
import Who from "../../components/home/Who";
import ChooseUs from "../../components/home/ChooseUs";
import ServicesCard from "../../components/home/ServicesCard";
import Portfolio from "../../components/home/Portfolio";
import Testimonial from "../../components/home/Testimonial";
import Quote from "../../components/home/Quote";
import Blogs from "../../components/home/Blogs";
import { useNavigate } from "react-router-dom";
import Arrow from "../../assest/arrow.png";
import ProjectImg from "../../assest/project-card.png";
import HappyImg from "../../assest/Happy.png";
import ExerinesImg from "../../assest/Experinces.png";
import SupportImg from "../../assest/Support.png";
import { useSelector } from "react-redux";
import FaqSection from "../../components/about/FAQ";
import BgVideo from '../../assest/Videos/one.mp4'

// Translation dictionaries
const translations = {
  en: {
    heroTitle: "Your Trusted Partner in <span>Construction</span>",
    heroSubtitle: "We deliver solutions that drive your business forward.",
    heroDescription: "Trusted by Industry Leaders Like Saudi Technic, Saudi Arabia Railways, Ministry of Health, Ministry of Interior & More",
    exploreServices: "Explore Services",
    stats: {
      projectsCompleted: "Projects Completed",
      happyClients: "Happy Clients",
      yearsExperience: "Years Experience",
      supportAvailable: "Support Available"
    }
  },
  sa: {
    heroTitle: "شريكك الموثوق في <span>البناء</span>",
    heroSubtitle: "نقدم حلولاً تدفع عملك إلى الأمام.",
    heroDescription: "موثوق به من قبل قادة الصناعة مثل السعودية الفنية، سكك الحديد السعودية، وزارة الصحة، وزارة الداخلية وغيرها",
    exploreServices: "استكشف الخدمات",
    stats: {
      projectsCompleted: "المشاريع المكتملة",
      happyClients: "عملاء سعداء",
      yearsExperience: "سنوات الخبرة",
      supportAvailable: "دعم متاح"
    }
  },
  fr: {
    heroTitle: "Votre partenaire de confiance en <span>Construction</span>",
    heroSubtitle: "Nous proposons des solutions qui font avancer votre entreprise.",
    heroDescription: "Reconnu par les leaders du secteur comme Saudi Technic, Saudi Arabia Railways, Ministry of Health, Ministry of Interior et plus encore",
    exploreServices: "Explorer les services",
    stats: {
      projectsCompleted: "Projets terminés",
      happyClients: "Clients satisfaits",
      yearsExperience: "Années d'expérience",
      supportAvailable: "Support disponible"
    }
  },
  de: {
    heroTitle: "Ihr vertrauenswürdiger Partner im <span>Bauwesen</span>",
    heroSubtitle: "Wir liefern Lösungen, die Ihr Unternehmen voranbringen.",
    heroDescription: "Vertrauen von Branchenführern wie Saudi Technic, Saudi Arabia Railways, Ministry of Health, Ministry of Interior und mehr",
    exploreServices: "Dienste erkunden",
    stats: {
      projectsCompleted: "Abgeschlossene Projekte",
      happyClients: "Zufriedene Kunden",
      yearsExperience: "Jahre Erfahrung",
      supportAvailable: "Unterstützung verfügbar"
    }
  }
};

const Home = () => {
  const { language } = useSelector((state) => state.language);
  const [hoverButton, setHoverButton] = useState(false);
  const navigate = useNavigate();

  const handleQat = () => {
    navigate("/Genral-contarcting");
  };
  const handleExploreServicesClick = () => {
    navigate("/services");
  };

  const t = translations[language] || translations.en;

  const stats = [
    {
      image: ProjectImg,
      title: "500+",
      text: t.stats.projectsCompleted,
    },
    {
      image: HappyImg,
      title: "200+",
      text: t.stats.happyClients,
    },
    {
      image: ExerinesImg,
      title: "15+",
      text: t.stats.yearsExperience,
    },
    {
      image: SupportImg,
      title: "24/7",
      text: t.stats.supportAvailable,
    },
  ];

  return (
    <>
      <style>
        {`
          .hero-container {
            position: relative;
            display: flex;
            flex-direction: column;
          }
          .hero-content {
            flex: 1;
            padding-top: 3rem;
            padding-bottom: 2rem;
          }
          .stat-cards-row {
            padding-bottom: 2rem;
          }
          @media (max-width: 991.98px) {
            .hero-content {
              text-align: center;
              padding-top: 4rem;
            }
          }
          @media (max-width: 575.98px) {
            .hero-content {
              padding-top: 3rem;
            }
            .stat-card {
              max-width: 280px;
              margin-left: auto;
              margin-right: auto;
            }
          }

          @media (min-width: 992px) {
            .stat-cards-row {
              margin-top: -160px !important;
            }
          }

          /* RTL support for Arabic */
          [dir="rtl"] .hero-content {
            text-align: right;
          }
          [dir="rtl"] .hero-button-content {
            flex-direction: row-reverse;
          }
        `}
      </style>

      <section
        className="hero-section"
        style={{
          position: 'relative',
          overflow: 'hidden',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center'
        }}
        dir={language === 'ar' ? 'rtl' : 'ltr'}
      >
        {/* Video Background */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: -1,
          overflow: 'hidden'
        }}>
          <video
            autoPlay
            loop
            muted
            playsInline
            style={{
              width: '100%',
              height: '85%',
              objectFit: 'cover'
            }}
          >
            <source src={BgVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          {/* Dark overlay for better text contrast */}
          {/* <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.4)'
          }}></div> */}
        </div>

        <div className="container text-white hero-container">
          <div className="hero-content">
            <div className="row">
              <div className="col-12 col-lg-6">
                <h1
                  className="fw-bold"
                  style={{
                    fontSize: "clamp(1.8rem, 5vw, 3rem)",
                    lineHeight: "1.3",
                    marginBottom: "0.8rem",
                  }}
                  dangerouslySetInnerHTML={{ __html: t.heroTitle }}
                />
                <p
                  className="lead"
                  style={{
                    fontSize: "clamp(0.9rem, 2.5vw, 1.1rem)",
                    margin: "0.5rem 0",
                  }}
                >
                  {t.heroSubtitle}
                </p>
                <h1
                  className="fw-semibold"
                  style={{
                    fontSize: "clamp(0.8rem, 2vw, 1rem)",
                    marginBottom: "3rem",
                  }}
                >
                  {t.heroDescription}
                </h1>
                <button
                  className={`btn d-inline-flex align-items-center hero-button-content ${hoverButton ? "btn-dark" : "btn-danger"}`}
                  onMouseEnter={() => setHoverButton(true)}
                  onMouseLeave={() => setHoverButton(false)}
                  style={{
                    borderRadius: "50px",
                    gap: "0.5rem",
                    padding: "0.65rem 1.3rem",
                    fontSize: "clamp(0.8rem, 2.2vw, 0.9rem)",
                    transition: "all 0.3s ease",
                    transform: hoverButton ? "scale(1.1)" : "scale(1)",
                    boxShadow: hoverButton
                      ? "0 0 10px rgba(255, 255, 255, 0.5)"
                      : "none",
                  }}
                  onClick={handleExploreServicesClick}
                >
                  {t.exploreServices}
                  <img
                    src={Arrow}
                    alt="Arrow Icon"
                    style={{
                      height: "28px",
                      transition: "transform 0.3s ease",
                      transform: hoverButton
                        ? language === "ar"
                          ? "translateX(-6px)"
                          : "translateX(6px)"
                        : "none",
                    }}
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="row justify-content-center g-3 stat-cards-row">
          {stats.map(({ image, title, text }, index) => (
            <div
              key={index}
              className="col-10 col-sm-6 col-md-5 col-lg-3 mb-3 stat-card"
            >
              <div
                className="card text-center shadow-sm p-3 h-100 bg-white rounded-4"
                style={{
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  border: "1px solid rgba(0,0,0,0.1)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.03) translateY(-8px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 20px rgba(0,0,0,0.15), 0 0 10px rgba(255, 255, 255, 0.3)";
                  e.currentTarget.style.border = "1px solid rgba(255, 0, 0, 0.5)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1) translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 6px rgba(0,0,0,0.1)";
                  e.currentTarget.style.border = "1px solid rgba(0,0,0,0.1)";
                }}
              >
                <div className="mb-2">
                  <img
                    src={image}
                    alt={title}
                    className="img-fluid"
                    style={{ height: "45px", objectFit: "contain" }}
                  />
                </div>
                <h2
                  className="fw-bold"
                  style={{ fontSize: "clamp(0.9rem, 2.5vw, 1.1rem)" }}
                >
                  {title}
                </h2>
                <p
                  className="small text-muted mb-0"
                  style={{ fontSize: "clamp(0.7rem, 1.8vw, 0.85rem)" }}
                >
                  {text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div
        className="spacer"
        style={{
          height: "20px",
        }}
      ></div>

      {/* Sections */}

      <Who />
      <ChooseUs />
      <ServicesCard />
      <Portfolio />
      <Testimonial />
      <Blogs />
      <Quote />
      <FaqSection />

    </>
  );
};

export default Home;